import { motion } from 'framer-motion';
import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const PersonSelectWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 14px;

  padding: 16px 10px;

  border-radius: 8px;
  background: rgba(173, 173, 173, 0.08);

  ${({ theme }) =>
    theme.isError &&
    `
    padding: 15px 9px;
    border: 1px solid var(--color-error);
  `}

  cursor: pointer;
  position: relative;
`;

export const PersonSelectInput = styled.input`
  height: 100%;
  flex: 1;

  font-weight: 500;
  font-size: 14px;
  line-height: normal;

  color: var(--color-text);

  border: none;
  outline: none;
  background: transparent;

  ${BREAKPOINTS.tablet} {
    font-size: 16px;
  }

  &::placeholder {
    font-size: 14px;
    font-weight: 400;
    line-height: normal;

    color: var(--color-data-alumni-background);
  }
`;

export const PersonSelectIconContainer = styled.div`
  min-width: 44px;
  min-height: 44px;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 100%;
`;

export const PersonSelectSearchIconContainer = styled.div`
  width: 44px;
  height: 44px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 100%;
  background: var(--color-primary);
`;

export const PersonSelectOptionsContainer = styled(motion.div).attrs({
  animate: { maxHeight: 200 },
  initial: { maxHeight: 0 },
  exit: { maxHeight: 0 },
})`
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;

  border-radius: 0px 0px 8px 8px;

  background: #ffffff;

  transform: translateY(calc(100% - 4px));

  overflow: auto;
  z-index: 2;

  & > :last-child {
    padding-bottom: 19px;
  }
`;

export const PersonSelectOptionContainer = styled.div`
  padding: 3px 24px 3px 18px;

  &:hover {
    background: #f5f5f5;
  }
`;

export const PersonSelectOptionLabel = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: normal;

  color: var(--color-text);
`;

// SELECTED PEOPLE
export const PersonSelectSelectedPeopleContainer = styled.div`
  flex: 1;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;

  overflow-x: auto;

  scrollbar-width: thin;
  scrollbar-gutter: stable;
`;

export const PersonSelectSelectedPersonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  padding: 8px 24px;

  border-radius: 50px;
  background: var(--color-data-people-background);

  & > svg:first-child {
    mix-blend-mode: multiply;
  }

  & > [data-action='remove'] {
    display: none;

    ${BREAKPOINTS.tablet} {
      display: flex;
    }
  }

  &:hover {
    background: var(--color-data-people-background-hover);
    padding: 8px 6px 8px 24px;

    & > [data-action='remove'] {
      display: flex;
    }

    ${BREAKPOINTS.tablet} {
      padding: 4px 12px;
      background: var(--color-data-people-background);
    }
  }

  ${BREAKPOINTS.tablet} {
    padding: 4px 12px;
  }
`;

export const PersonSelectSelectedPersonLabel = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 28px;

  color: var(--color-text);
`;

export const PersonSelectSelectedPersonRemoveContainer = styled.div`
  width: 24px;
  height: 24px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  cursor: pointer;
`;
